import { Component } from "react";
import * as Scrivito from "scrivito";

class SelectOptionWidgetComponent extends Component {
  render() {
    const { widget } = this.props;
    const value = widget.get("text");

    return <option value={value}>{value}</option>;
  }
}

Scrivito.provideComponent("SelectOptionWidget", SelectOptionWidgetComponent);

export default Scrivito.connect(SelectOptionWidgetComponent);
